module.exports = __webpack_public_path__ + "img/investimento.0c262326.svg";